export enum DashboardSearchType {
  Codes = 'codes',
  Email = 'email',
  Cpf = 'cpf',
  Ean = 'ean',
}

export type DashboardSearchForm = {
  searchType: DashboardSearchType;
  codes: string;
  email: string;
  cpf: string;
  ean: string;
  filterDate: string;
};

export type DashboardFilterForm = {
  startDate: number;
  endDate: number;
  salesModes: string[];
  statuses: string[];
  deliveryModes: string[];
  filterDate: string;
};
